var path = '/templates/order/summary/shoppingCartModifierGroups.html';
var html = "<div ng-repeat=\"modifierGroup in option.modifierGroups\">\n    <div>{{modifierGroup.name}}</div>\n    <div ng-include=\"'/templates/order/summary/shoppingCartOptions.html'\"></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;